import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import Survey from '../../components/Survey';
import { AnimatedLoadingOverlay } from '../../components/AnimatedLoadingOverlay/AnimatedLoadingOverlay';
import { getShouldShowSurvey } from './utils/getShouldShowSurvey';

export class SyncOverlay extends Component {
    static propTypes = {
        scrollIntoView: PropTypes.bool,
        directoryId: PropTypes.number,
        surveyQuestionsData: PropTypes.shape({
            questions: PropTypes.arrayOf(
                PropTypes.shape({
                    answers_selected: PropTypes.arrayOf(
                        PropTypes.shape({
                            answer_id: PropTypes.number,
                            display_text: PropTypes.string,
                            free_text_response: PropTypes.string,
                            is_free_text: PropTypes.bool,
                        })
                    ),
                    display_text: PropTypes.string,
                    event_timestamp_utc: PropTypes.string,
                    event_type: PropTypes.string,
                    input_type: PropTypes.string,
                    possible_answers: PropTypes.arrayOf(
                        PropTypes.shape({
                            answer_id: PropTypes.number,
                            display_text: PropTypes.string,
                            free_text_response: PropTypes.string,
                            is_free_text: PropTypes.bool,
                        })
                    ),
                    question_id: PropTypes.number,
                    question_order: PropTypes.number,
                })
            ),
            booking_id: PropTypes.string,
            client_platform: PropTypes.string,
            session_id: PropTypes.string,
            survey_id: PropTypes.string,
            survey_type: PropTypes.string,
            survey_subtype: PropTypes.string,
            tracking_id: PropTypes.string,
            user_agent: PropTypes.string,
        }),
        bookingId: PropTypes.string,
        isVaccineApt: PropTypes.bool,
        isReschedule: PropTypes.bool,
    };

    overlayRef = React.createRef();
    state = {
        surveySubmitted: false,
    };

    componentDidMount() {
        const {
            directoryId,
            isReschedule,
            isVaccineApt,
            scrollIntoView,
            surveyQuestionsData,
        } = this.props;

        if (scrollIntoView) {
            const element = this.overlayRef.current;
            if (element) {
                element.scrollIntoView();
            }
        }

        const shouldShowSurvey = getShouldShowSurvey({
            directoryId,
            isReschedule,
            isVaccineApt,
            surveyQuestionsData,
        });

        this.setState({ shouldShowSurvey });
    }

    render() {
        const { bookingId, surveyQuestionsData } = this.props;
        const { shouldShowSurvey, surveySubmitted } = this.state;

        return (
            <OverlayContainer ref={this.overlayRef}>
                <AnimatedLoadingOverlay
                    shouldShowSurvey={this.state.shouldShowSurvey}
                    surveySubmitted={surveySubmitted}
                />
                {shouldShowSurvey && (
                    <Survey
                        bookingId={bookingId}
                        data-test="sync-overlay-survey"
                        onSubmitSurvey={this.handleSubmitSurvey}
                        surveySubmitted={surveySubmitted}
                        surveyQuestionsData={surveyQuestionsData}
                    />
                )}
            </OverlayContainer>
        );
    }

    handleSubmitSurvey = () => {
        this.setState({
            surveySubmitted: true,
        });
    };
}

const OverlayContainer = styled.div`
    width: 100%;
    background-color: white;

    ${breakpoint.small} {
        display: flex;
        align-items: center;
        flex-direction: column;
    }
`;
